import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IJobDocument, IJobPhase } from "../../../models"
import PhaseTable from "../../../components/phase/PhaseTable"
import { FloatingActionButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../../components/layout/TableActionBar"
import AppStateStore from "../../../stores/AppStateStore"
import AddPhaseDialog from "../../../components/phase/AddPhaseDialog"
import _ from "lodash"
import * as api from "../../../api"
import { checkPhaseFieldAvailable } from "../../../helpers/punchHelper"
import accountStore from "../../../stores/AccountStore"

interface IProps {
    readonly: boolean
    job: IJobDocument
    handleUpdateJob(job: IJobDocument): Promise<void>
}
interface IState {
    phases: IJobPhase[]
    selectedPhases: IJobPhase[]
    openAddPhaseDialog: boolean
    editPhase: IJobPhase
}

export default class IJobDetailPhases extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            phases: props.job.Phases ? props.job.Phases.filter(i => !i.Deleted) : [],
            selectedPhases: [],
            openAddPhaseDialog: false,
            editPhase: null
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            phases: nextProps.job.Phases ? nextProps.job.Phases.filter(i => !i.Deleted) : [],
        })
    }

    render() {
        return (
            <div className="detail-tab">
                {!this.props.readonly &&
                    <FloatingActionButton
                        data-intercom-target={"menu-Jobs-JobDetails-PhasesTab-Btn-Add"}
                        style={{ position: "relative", float: "right", right: 50, top: -45 }}
                        secondary
                        onTouchTap={() => this.setState({ openAddPhaseDialog: true })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <TableActionBar
                    rowSelectionCount={this.state.selectedPhases.length}
                    singleSelectedMessage={strings.Phase_Selected}
                    multipleSelectedMessage={strings.x_Phases_Selected}
                    title={checkPhaseFieldAvailable("singular") ? accountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel :strings.Phase}
                    searchText={""}
                    onDeleteClick={() => {
                        AppStateStore.setProgressSnackbarContent("loading")
                        api.allowDeleteOrInactivePhases(this.state.selectedPhases.map(e => e.Id)).then(res => {
                            AppStateStore.setProgressSnackbarContent(null)
                            res.data ?
                                AppStateStore.setConfirmDialogContent({
                                    content: strings.Are_you_sure_you_want_to_delete_the_selected_phase,
                                    confirm: () => {
                                        this.props.job.Phases.forEach(i => {
                                            if (this.state.selectedPhases.find(e => e.Id === i.Id)) {
                                                i.Active = false
                                                i.Deleted = true
                                            }
                                        })
                                        this.setState({ selectedPhases: [] })
                                        AppStateStore.setProgressSnackbarContent("loading")
                                        this.props.handleUpdateJob(this.props.job).then(() =>
                                            AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
                                        )
                                    }
                                }) :
                                AppStateStore.setAlertDialogContent({
                                    title: strings.Cannot_Delete_Phase,
                                    content: strings.Cannot_Delete_Phase_because_it_is_already_use
                                })
                        })
                    }}
                    readonly={this.props.readonly}
                />
                {!this.state.phases.length ?
                    <h2 style={{ textAlign: "center", marginTop: 25 }}>
                        { checkPhaseFieldAvailable("singular") ? `No ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel} Found` :  strings.No_phase_found}
                    </h2> :
                    <PhaseTable
                        readonly={this.props.readonly}
                        phases={this.state.phases}
                        selectedPhases={this.state.selectedPhases}
                        handleClickRow={editPhase => this.setState({ openAddPhaseDialog: true, editPhase })}
                        handleSelect={selectedPhases => this.setState({ selectedPhases })}
                    />
                }
                {this.state.openAddPhaseDialog &&
                    <AddPhaseDialog
                        editPhase={this.state.editPhase}
                        phases={this.state.phases}
                        handleAdd={phase => {
                            let phases = this.props.job.Phases
                            if (phases) {
                                phases.push(phase)
                            }
                            else {
                                phases = [phase]
                            }
                            this.setState({ openAddPhaseDialog: false, editPhase: null })
                            AppStateStore.setProgressSnackbarContent("loading")
                            this.props.job.Phases = phases
                            this.props.handleUpdateJob(this.props.job).then(() =>
                                AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                            )
                        }}
                        handleUpdate={phase => {
                            let phases = this.props.job.Phases
                            phases[phases.findIndex(i => i.Id === phase.Id)] = phase
                            this.setState({ openAddPhaseDialog: false, editPhase: null })
                            AppStateStore.setProgressSnackbarContent("loading")
                            this.props.job.Phases = phases
                            this.props.handleUpdateJob(this.props.job).then(() =>
                                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
                            )
                        }}
                        handleClose={() => this.setState({ openAddPhaseDialog: false, editPhase: null })}
                    />
                }
            </div >
        )
    }
}